import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { Link } from 'react-router-dom';

import { BalanceWidget } from '@/components/molecules/BalanceWidget';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { useTranslator } from '@/hooks/useTranslator';
import { DetailedBalance } from '@/types/bankInfo';
import { CurrencyCodeType } from '@/types/currency';
import { Permission } from '@/types/permissions';

interface Props {
  readonly balances?: readonly DetailedBalance[];
}

export const BalanceLayout: React.FC<Props> = (props: Props): React.ReactElement => {
  const { balances = [DetailedBalance.zero(CurrencyCodeType.USDC)] } = props;
  const { userIsAuthorizedTo } = usePermissionsManager();

  const tr = useTranslator();

  return (
    <Box display="flex" flexDirection="column" px={4} py={5} gap={3}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h7">{tr('ACCOUNT')}</Typography>
        {userIsAuthorizedTo(Permission.CREATE_TRANSACTIONS) && (
          <ButtonBase component={Link} to="convert" sx={styles.button}>
            <Typography fontSize={16} fontWeight={400} lineHeight="24px">
              {tr('CONVERT')}
            </Typography>
          </ButtonBase>
        )}
      </Box>
      {balances.map(
        (balance: DetailedBalance): React.ReactElement => (
          <BalanceWidget key={balance.currencyCode} balance={balance} />
        ),
      )}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  button: {
    height: 40,
    width: 110,
    lineHeight: '40px',
    backgroundColor: 'custom.InputsBackground',
    borderRadius: 5,
  },
};
